// extracted by mini-css-extract-plugin
export default {"dateTime":"AgreementDetail_dateTime__5v9zI","label":"AgreementDetail_label__mOSjv","text":"AgreementDetail_text__SmVYH","title":"AgreementDetail_title__YTNxQ"};